import { render, staticRenderFns } from "./ProhibitedIcon.vue?vue&type=template&id=155a9f93&"
import script from "./ProhibitedIcon.vue?vue&type=script&lang=js&"
export * from "./ProhibitedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports